import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.index');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-page-admin-index',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.index/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminIndexComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        location.replace('/admin/dashboard');
    }
}

export default PageAdminIndexComponent;